import { Component, Input, inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RouterModule,
} from '@angular/router';
import { map, Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { IconService } from '../../_services/icon.service';

@Component({
  selector: 'app-static-header',
  templateUrl: './static-header.component.html',
  styleUrls: ['./static-header.component.scss'],
  standalone: true,
  imports: [MatToolbarModule, MatIconModule, RouterModule, MatButtonModule],
})
export class StaticHeaderComponent {
  @Input() isDisabled: boolean = false;
  name: string = '';
  surname: string = '';
  role: string = '';

  saveSubscription?: Subscription;

  private router = inject(Router);
  constructor(iconService: IconService) {
    iconService.getIcons(['exit']);
  }

  close() {
    const idPratica = this.router.url.split('/').pop();
    idPratica && this.router.navigate([`pratica/${idPratica}`]);
  }
}
